import { useQuery } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";

const fetchDigest = async (digestUrl: string) =>
  await axios({ method: "get", url: digestUrl, withCredentials: false })
    .then((response) => response.data)
    .catch((error) => {
      if (AxiosError.ERR_NETWORK) {
        console.error(`Could not find ${digestUrl}`);
        return null;
      }

      // Something unexpected
      throw error;
    });

export default function useDigestQuery({
  digestUrl,
  anchorID,
}: Record<string, any>): any {
  return useQuery({
    queryKey: [`digest-` + anchorID],
    queryFn: () => fetchDigest(digestUrl),
    suspense: true,
  });
}
